/* eslint-disable no-undef */
/**
 * Handles user specific actions
 */
export default class UserService {
  /**
   * Timeout
   * @type {number}
   */
  static BonusTimeout = 0;

  static extraTimeout = 0;

  /**
   * Time since last CalculcateBonus request
   */
  static LastCall = Date.now();

  /**
   * Store login state in local storage so we can
   * execute bonus request only on first login reload
   */
  static setLoginState() {
    return
  }

  /**
   * Execute bonus request only if user is logged in
   */
  static getUserBounsInfo() {
    return;
  }

  /**
   * Check if user is logged in
   * @returns {boolean}
   */
  static userLoggedIn() {
    return typeof APP_SETTINGS.player !== 'undefined' &&
      typeof APP_SETTINGS.player.token !== 'undefined' &&
      APP_SETTINGS.player.token !== '' &&
      typeof APP_SETTINGS.player.id !== 'undefined' &&
      APP_SETTINGS.player.id;
  }
}
